<app-whatsapp-button></app-whatsapp-button>
<div class="container">
    <div class="row justify-content-center">
        <div class="col-12 col-lg-6">
            <h1 [innerHTML]="pageTitle">Atendimento - Pagmob</h1>
            <p>Agora você pode gerar a sua nova senha.</p>
        </div> <!-- /col -->
    </div> <!-- /row -->

    <div class="row justify-content-center" [ng2-loading]="showSpinner">
        <div class="col-lg-6">

            <div class="row">
                <div class="col-12">
                    <div class="form-panel">
                        <h2>Alteração de senha</h2>

                        <p>Digite a nova senha e a confirmação:</p>
                        <form name="form" (ngSubmit)="f.form.valid && enviarSenha()" #f="ngForm">
                            <div class="form-group" [ngClass]="{ 'invalid': (senha.invalid && senha.touched) || (senha.invalid && f.submitted) }">
                                <label for="senha">Senha</label>
                                <input type="password" class="form-control" id="senha" name="senha" placeholder="" [(ngModel)]="model.senha" #senha="ngModel" required>
                            </div>

                              <div class="form-group" [ngClass]="{ 'invalid': (csenha.invalid && csenha.touched) || (csenha.invalid && f.submitted) }">
                                <label for="csenha">Confirma Senha</label>
                                <input type="password" class="form-control" id="csenha" name="csenha" placeholder="" [(ngModel)]="model.csenha" #csenha="ngModel" required>
                              </div>
                          <div><span *ngIf="model.senha && model.csenha && model.senha.length >= 8 && model.csenha.length >= 8 && model.senha.length <= 20 && model.csenha.length <= 20">✔</span><span *ngIf="!(model.senha && model.csenha && model.senha.length >= 8 && model.csenha.length >= 8 && model.senha.length <= 20 && model.csenha.length <= 20)">❌</span> Sua senha deve ter entre 8 e 20 caracteres️</div>
                          <div><span *ngIf="model.senha && model.csenha && testNumber(model.senha,model.csenha)">✔</span><span *ngIf="!(model.senha && model.csenha && testNumber(model.senha,model.csenha))">❌</span> Pelo menos um número️</div>
                          <div><span *ngIf="model.senha && model.csenha && testLetter(model.senha,model.csenha)">✔</span><span *ngIf="!(model.senha && model.csenha && testLetter(model.senha,model.csenha))">❌</span> Pelo menos uma letra maiúscula ou minúscula</div>
                          <div><span *ngIf="model.senha && model.csenha && testSpecial(model.senha,model.csenha)">✔</span><span *ngIf="!(model.senha && model.csenha && testSpecial(model.senha,model.csenha))">❌</span> Um caractere especial</div>
                          <br>
                            <button type="submit" class="btn btn-primary btn-block mb-3">Confirmar</button>
                        </form>
                    </div>
                </div>
                <button id="openModal" #openModal [hidden]="true" data-toggle="modal" data-target="#mail-modal"></button>
            </div>


            <!-- Modal -->
            <div class="modal fade" id="mail-modal" tabindex="-1" role="dialog" aria-labelledby="mail-modal-lLabel"
                aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h2><img src="assets/icons/mail.svg" alt="Ícone de e-mail"> E-mail enviado</h2>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div> <!-- /modal-header -->
                        <div class="modal-body">
                            <p>Pronto!</p>

                            <div class="row mt-2">
                                <div class="col-12">
                                    <p class="caption gray">Agora você pode tentar realizar o acesso novamente.</p>
                                </div>
                                <div class="col-6">
                                    <button type="button" class="btn btn-primary btn-block" routerLink="/" data-dismiss="modal">Ok</button>
                                </div>
                            </div> <!-- /row -->
                        </div> <!-- /modal-body -->
                    </div> <!-- /modal-content -->
                </div> <!-- /modal-dialog -->
            </div> <!-- /modal -->

        </div> <!-- /form -->
    </div> <!-- /row -->

    <div class="row justify-content-center">
        <div class="col-6">
            <a routerLink="/" class="btn btn-link">&lt; Voltar</a>
        </div>
    </div>
</div> <!-- /container -->
